import script from "./PrimeMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimeMenu.vue?vue&type=script&setup=true&lang=js"

import "./PrimeMenu.vue?vue&type=style&index=0&id=651efd0e&lang=css"

const __exports__ = script;

export default __exports__